import { configureStore } from '@reduxjs/toolkit';
import uiReducer from './slices/uiSlice';
import languageReducer from './slices/languageSlice';
import themeReducer from './slices/themeSlice';
import userReducer from './slices/userSlice';
import groupsReducer from './slices/groupsSlice';
import messagesReducer from './slices/messagesSlice';
import notificationsReducer from './slices/notificationsSlice';

export const store = configureStore({
  reducer: {
    ui: uiReducer,
    language: languageReducer,
    theme: themeReducer,
    user: userReducer,
    groups: groupsReducer,
    messages: messagesReducer,
    notifications: notificationsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

export default store;
